package com.checkin.host.ui.billing

import kotlinx.browser.window
import org.w3c.dom.url.URLSearchParams

data class BillingCheckoutReturn(
    val planId: String?,
)

fun billingCheckoutReturnFromWindow(): BillingCheckoutReturn? {
    val params = URLSearchParams(window.location.search)
    if (params.get("billing") != "success") return null
    return BillingCheckoutReturn(planId = params.get("plan"))
}

fun clearBillingQueryParams() {
    window.history.replaceState(null, "", window.location.pathname + window.location.hash)
}
